module.exports = __webpack_public_path__ + "img/medal-silver.bdf006dc.svg";